


import React, { useState, useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import desktopIcon from "../../assets/images/desktopIcon.png";
import starIcon from "../../assets/images/star.png";
import { AuthContext } from "../../context/AuthContext";

const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.plutonic.mobile";

function TherapyRoomCard({
  room,
  isSelected,
  onSelect,
  onEnterClick,
  sessions = [],
  preloadState,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isStarHovered, setIsStarHovered] = useState(false);
  const [selectedSession, setSelectedSession] = useState(
    sessions.find((s) => s.isAvailable || s.isUpcoming) || null
  );
  useEffect(() => {
    const newSelectedSession = sessions.find((s) => s.isAvailable || s.isUpcoming) || null;
    setSelectedSession(newSelectedSession);
  }, [sessions]);
  const primarySession = sessions.find((s) => s.isPrimary) || null;
  const filteredSessions = sessions.filter(s => s.isAvailable || s.isUpcoming);
const {
    userType,
    
  } = useContext(AuthContext);

  // ✅ Destructure from room object
  const {
    image,
    title,
    description,
    accessibility,
    style,
    available,
    isComingSoon,
    unavailableLabel,
    online,
  } = room;
  const preloadBlocksEntry = preloadState?.blocksEntry === true;
  const isPreloading = ["checking", "queued", "loading"].includes(preloadState?.status);
  const preloadProgress = Math.round((preloadState?.progress || 0) * 100);
  const supportsAndroid = room.id === "beach";


  return (
    <div
      className={`therapy-room-card bg-black text-white rounded-3xl shadow-lg p-4 sm:p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto transition-shadow duration-300 border-2 cursor-pointer ${
        isComingSoon
  ? isHovered
    ? "cursor-not-allowed border-[8px] border-transparent [background:linear-gradient(#000,#000)_padding-box,linear-gradient(90deg,#8B5CF6,#4C1D95,#00F5D4)_border-box] shadow-[0_0_35px_rgba(0,245,212,0.45)]"
    : "cursor-not-allowed border-[8px] border-transparent"
          : isSelected
          ? " border-[8px] border-[#22AAEE]"
          : isHovered
          ? " border-[8px] border-[#22AAEE]"
          : "border-transparent"
      }`}
      style={{
        position: "relative",
        overflow: "visible",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onSelect}
    >
      {/* Star Icon */}
      {isSelected && (
        <div
          className="absolute top-0 left-0 z-20"
          style={{ transform: "translate(-45%, -65%)" }}
          onMouseEnter={() => setIsStarHovered(true)}
          onMouseLeave={() => setIsStarHovered(false)}
        >
          <img src={starIcon} alt="Selected" className="w-13 h-12" />
          {isStarHovered && (
            <span className="absolute bg-white text-black text-xs px-2 py-2 rounded-xl shadow-lg" style={{ top: "-20px", left: "80%", zIndex: 30 }}>
              {userType === "Client" ? "Your preferred space" : "Client's preferred space"}
            </span>
          )}
        </div>
      )}

      {/* Online Badge */}
      {online && (
        <div
          className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
          style={{
            top: "-15px",
            right: "10px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            zIndex: 10,
          }}
        >
          <span className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2 inline-block"></span>
          <span>Online</span>
        </div>
      )}

      {/* Image */}
      <div
        className="relative w-full h-40 sm:h-48 rounded-lg mb-4 overflow-hidden"
      >
        <img
          src={image}
          alt={title}
          className={`therapy-room-card__image absolute inset-0 w-full h-full object-cover ${isPreloading ? "grayscale" : ""}`}
        />
        {isPreloading && (
          <>
            <img
              src={image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover transition-[clip-path] duration-200 ease-out"
              style={{ clipPath: `inset(0 ${100 - preloadProgress}% 0 0)` }}
              aria-hidden="true"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/20">
              <span className="rounded-full bg-black/75 px-4 py-2 text-sm font-semibold text-white shadow-lg">
                {preloadState.status === "checking"
                  ? "Checking for updates…"
                  : preloadState.status === "queued"
                  ? "Waiting to prepare…"
                  : `Preparing your space… ${preloadProgress}%`}
              </span>
            </div>
          </>
        )}
      </div>

      {/* Title & Description */}
      <div className="therapy-room-card__summary mb-4" style={{ minHeight: "120px" }}>
        <h3 className="font-medium mb-2" style={{ fontSize: "var(--font-size-title)" }}>{title}</h3>
        <p className="font-medium" style={{ fontSize: "var(--font-size-description)" }}>{description}</p>
      </div>

      {/* Metadata */}
      <div className="therapy-room-card__metadata" style={{ minHeight: "100px" }}>
        <div className="mb-2 flex flex-wrap items-center gap-x-2 gap-y-2 font-medium" style={{ fontSize: "var(--font-size-small)" }}>
          <span>Accessibility | {accessibility}</span>
          <span className="inline-flex items-center">
            <img src={desktopIcon} alt="Accessibility Icon" className="w-[18px] h-[18px]" />
          </span>
          {supportsAndroid && (
            <>
              <span className="font-medium text-white" style={{ fontSize: "var(--font-size-small)" }}>Android</span>
              <a
                href={ANDROID_PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
                aria-label="Get Plutonic on Google Play"
                className={`inline-flex items-center text-[#22AAEE] transition hover:text-[#63c9f5] focus:outline-none focus:ring-2 focus:ring-[#22AAEE] ${isMobile ? "" : "min-h-8 gap-1.5 rounded-md border border-[#22AAEE]/70 bg-[#07131a] px-2.5 py-1 shadow-md hover:border-[#22AAEE] hover:bg-[#0b202b]"}`}
              >
                {isMobile ? (
                  <svg data-testid="android-mobile-icon" aria-hidden="true" viewBox="0 0 24 24" className="h-[18px] w-[18px] shrink-0 fill-current">
                    <path d="m7.1 6.8-1.3-2.2a.55.55 0 0 1 .95-.55l1.34 2.32A7.1 7.1 0 0 1 12 5.25c1.42 0 2.76.41 3.9 1.12l1.34-2.32a.55.55 0 0 1 .95.55l-1.28 2.2A6.4 6.4 0 0 1 19 10.5H5a6.4 6.4 0 0 1 2.1-3.7ZM5 11.5h14v6.1c0 .77-.63 1.4-1.4 1.4H17v1.5a1 1 0 0 1-2 0V19H9v1.5a1 1 0 0 1-2 0V19h-.6A1.4 1.4 0 0 1 5 17.6v-6.1Zm-2 0a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0v-5Zm16 0a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0v-5Z" />
                    <circle cx="8.5" cy="8.25" r=".7" fill="black" />
                    <circle cx="15.5" cy="8.25" r=".7" fill="black" />
                  </svg>
                ) : (
                <span data-testid="google-play-desktop-badge" className="inline-flex items-center gap-1.5">
                  <svg aria-hidden="true" viewBox="0 0 32 36" className="h-5 w-4 shrink-0 fill-current">
                    <path d="M1.8 1.8 18.7 18 1.8 34.2A4.5 4.5 0 0 1 .5 31V5c0-1.3.5-2.4 1.3-3.2Zm16.9 16.2 4.8-4.6L6.6.9C5.3 0 3.8.3 2.7 1.2L18.7 18Zm0 0-16 16.8c1.1.9 2.6 1.2 3.9.3l16.9-12.5-4.8-4.6Zm10.4-3.3-5.6-1.3-4.8 4.6 4.8 4.6 5.6-1.3c3.2-1.8 3.2-4.8 0-6.6Z" />
                  </svg>
                  <span className="leading-none">
                    <span className="block text-[7px] font-semibold uppercase tracking-wide">Get it on</span>
                    <span className="block whitespace-nowrap text-xs font-semibold">Google Play</span>
                  </span>
                </span>
                )}
              </a>
            </>
          )}
        </div>
        <p className="font-medium mb-2" style={{ fontSize: "var(--font-size-small)" }}>
          Virtual Space Style | {style}
        </p>
        {selectedSession?.sessionStartTimeEST && (
          <p className="font-medium text-[#22AAEE] mt-2" style={{ fontSize: "var(--font-size-small)" }}>
             Session Start Time: {selectedSession.sessionStartTimeEST}
          </p>
        )}
        

      </div>

      {/* Session Selector + Button */}
      <div className="therapy-room-card__actions w-full flex flex-col justify-center mt-2 max-w-[350px] mx-auto">
  {available && filteredSessions.length > 0 ? (
    filteredSessions.length === 1 ? (
      <button
        disabled={preloadBlocksEntry}
        onClick={() => {
          if (!preloadBlocksEntry) onEnterClick(filteredSessions[0].meetingID);
        }}
        className={`w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base transition duration-300 shadow-md ${preloadBlocksEntry ? "bg-gray-500 text-white cursor-not-allowed" : "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"}`}
      >
        {preloadBlocksEntry ? "CHECKING FOR UPDATES…" : "ENTER SESSION"}
      </button>
    ) : (
      <>
        <label htmlFor="sessionSelect" className="text-sm text-white mb-2 font-medium">
          Select a Session
        </label>
        <select
          id="sessionSelect"
          value={selectedSession?.meetingID || filteredSessions[0]?.meetingID || ""}
          onChange={(e) => {
            const selected = filteredSessions.find(s => s.meetingID === e.target.value);
            setSelectedSession(selected || null);
          }}
          className="w-full rounded-lg border border-[#22AAEE] bg-white text-black px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#22AAEE] transition duration-200 shadow-sm"
        >
          <optgroup label="Available Sessions">
            {filteredSessions.map((session) => (
              <option key={session.meetingID} value={session.meetingID}>
                {session.sessionStartTimeEST}
              </option>
            ))}
          </optgroup>
        </select>

        <button
          disabled={preloadBlocksEntry}
          onClick={() => !preloadBlocksEntry &&
            onEnterClick(
              selectedSession?.meetingID || filteredSessions[0]?.meetingID
            )
          }
          className={`mt-4 w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base transition duration-300 shadow-md ${preloadBlocksEntry ? "bg-gray-500 text-white cursor-not-allowed" : "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"}`}
        >
          {preloadBlocksEntry ? "CHECKING FOR UPDATES…" : "ENTER SESSION"}
        </button>
      </>
    )
  ) : (
    <button
      disabled
      className="font-semibold rounded-full bg-gray-500 text-white w-full px-6 py-3 text-sm md:text-base cursor-not-allowed shadow-sm"
    >
      {unavailableLabel || (isComingSoon ? "Coming Summer 2026" : "UNAVAILABLE")}
    </button>
  )}
</div>


    </div>
  );
}

export default TherapyRoomCard;
